import PraisoServices from "./PraisoServices";

export const ForgotPasswordAPI = async (email) => {
  const ApiUrl = `auth/forgotPassword`;
  try {
    const response = await PraisoServices(
      ApiUrl,
      "post",
      {
        email: email,
        deviceType: 0,
      },
      {},
      {}
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const doForgotPassword = async (email) => {
  const data = await ForgotPasswordAPI(email);
  return data;
  // if (data.status.code !== 0 && data.status.code !== 200 && data.status.code !== 201) {
  //   return data;
  // } else {
  //   return data;
  // }
};
